import React from "react";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png";
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import { useCreateAddressMutation } from "../../../../store/api/address";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Tab1 from "./Tab1";
import Tab2 from "./Tab2";
import {
	useGetDoctypeDetailsQuery,
	useGetDoctypeitemQuery,
	useLazyGetDoctypeitemQuery,
} from "../../../../store/api/address";
import { usePageState } from "../../../../Hook/usePageState";
function Address() {
	const location = useLocation();

	const navigate = useNavigate();
	const [selectedCompanyaccounts, setSelectedCompanyAccounts] = useState("");
	const [createAddress, { isLoading, iserror, data }] =
		useCreateAddressMutation();
	// const [tab, settab] = useState(1);
	const [res, setRes] = useState(false);
	const [error, setError] = useState("");
	const [ptype, setptype] = useState("Error");
	const [showError, setShowError] = useState(false);
	const [isyca, setyca] = useState(0);
	const [status, setStatus] = useState(false);

	const pageStateDefault = {
		tab: 1,
		addressTitle: "",
		AddressType: "",
		AddressLine1: "",
		AddressLine2: "",
		Country: "",
		City: "",
		State: "",
		postalCode: "",
		email: "",
		phone: "",
		Fax: "",
		taxCategory: "",
		pba: false,
		psa: false,
		Disabled: false,
	}
	const [pageState, setPageState] = usePageState(`Create Address`, pageStateDefault);

	const { tab, addressTitle, AddressType, AddressLine1, AddressLine2, Country, City, State, postalCode, email, phone, Fax, taxCategory, pba, psa, Disabled } = pageState


const handleInputChange1 = (f, v) => {
  console.log("Field:", f);
  console.log("Value:", v);
  setPageState({ ...pageState, [f]: v });
};

	const handleSubmit = async () => {
		const payload = {
			address_title: pageState.addressTitle,
			address_type: pageState.AddressType,
			address_line1: pageState.AddressLine1,
			address_line2: pageState.AddressLine2,
			city: pageState.City,
			state: pageState.State,
			country: pageState.Country,
			pincode: pageState.postalCode,
			email_id: pageState.email,
			phone: pageState.phone,
			fax: pageState.Fax,
			tax_category: pageState.taxCategory,
			is_primary_address: pageState.pba ? 1 : 0,
			is_shipping_address: pageState.psa ? 1 : 0,
			disabled: pageState.Disabled ? 1 : 0,
			links: selectedCompanyaccounts,
			is_your_company_address: isyca ? 1 : 0,
		};
		console.log("Payload: ", payload)
		try {
			const res = await createAddress(payload).unwrap();
			setError("Address created successfully!");
			setptype("Success");
			setStatus(true);
			setShowError(true);
			 setPageState(pageStateDefault);
			setTimeout(() => {
				navigate("/master/address/address-list");
			}, 3000);
		} catch (error) {
			const parsedMessages = JSON.parse(error.data._server_messages);
			const firstMessageObj = JSON.parse(parsedMessages[0]);
			console.log(firstMessageObj, "errr");
			setError(firstMessageObj.message);
			setptype("Error");
			setShowError(true);
		}
	};
	return (
		<>
			<FormLayoutTwo
				title="New Address"
				breadcrumbs={[
					{ label: "Address" },
					{ label: "Address List", url: "/master/address/address-list" },
				]}
				status={"hide"}
				actionButtons={
					<>
						<Button
							className="custom-btn-00989"
							iconName="LuFilePlus2"
							style={{ gap: "2px", height: "28px" }}
							onClick={handleSubmit}
							iconSize={12}
						>
							{/* {po_response.result ? 'Submit' : 'Save'} */}save
						</Button>

						<Button
							to="/brand/create-brand"
							className="px-2"
							imgSrc={printerimg}
							imgStyle={{ width: "21px" }}
						/>
					</>
				}
			>
				<div
					className=""
					style={{ width: "100%", backgroundColor: "#fff", flexGrow: "1" }}
				>
					<div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
						<div className="d-flex justify-content-between align-items-end ">
							<ul
								className="nav nav-tabs"
								style={{ color: "white", border: "none" }}
							>
								<li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
									<a
										className={
											tab == 1
												? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
												: "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
										}
										 onClick={() => setPageState({ ...pageState, tab: 1 })}
										href="javascript:void(0);"
									>
										General Details
										{tab == 1 ? (
											<GetIcon iconName="MdKeyboardArrowDown" size={15} />
										) : (
											<GetIcon iconName="MdKeyboardArrowRight" size={15} />
										)}
									</a>
								</li>
							</ul>
							<div
								className="d-flex align-items-center mb-2 px-3"
								style={{ gap: "2px", fontSize: "12px" }}
							>
								<span style={{ position: "relative", top: "-1px" }}>
									<GetIcon className="text-[#4B002B]" iconName="CgAttachment" size={12} />
								</span>
								<span className="fw-semibold" style={{ color: "#4B002B" }}>
									Attachments
								</span>
							</div>
						</div>
					</div>

					<div className=" " style={{ background: '' }}>
						<div className="row">
							<div className="col-12">
								<div className="sidebarbox m-0">
									<Tab1
										pageState={pageState}
										  handleChange={handleInputChange1}
										// setFormData={setFormData}
										 onInputChange={(f, v) => setPageState({ ...pageState, [f]: v })}
									/>
								</div>
								<div className="">
									<Tab2
										setSelectedCompanyAccounts={setSelectedCompanyAccounts}
										isyca={isyca}
										setyca={setyca}
										doctype={location?.state?.doctype}
										idData={location?.state?.itemID}
									/>
								</div>

							</div>
						</div>
					</div>


				</div>
				<ApiResponseBox
					poptype={ptype}
					show={showError}
					errorMessage={error}
					onClose={() => setShowError(false)}
				/>
			</FormLayoutTwo>
		</>
	);
}

export default Address;
